export var ReminderId;
(function (ReminderId) {
    ReminderId["vitaminB12"] = "vitaminB12";
    ReminderId["omega3"] = "omega3";
})(ReminderId || (ReminderId = {}));
